import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import { getSessionStorageItem } from '@grandvisionhq/utils';
import { useServerStoreDataContext } from '../context/with-server-store-data-context.js';
import { useBrPageContext } from '../context/context.js';
import '@bloomreach/react-sdk';
import '../context/configuration.js';
import '@swc/helpers';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import { getBrPageContent } from '../utils/get-br-page-content.js';
import '@grandvisionhq/common';
import '../utils/http-client.js';
import { applyBloomreachAppointmentUrlsConfiguration } from './helpers/apply-bloomreach-appointment-urls-configuration.js';
import { formatRouteForAAB } from './helpers/format-route-for-aab.js';
import { urlFromSessionStorageItem } from './helpers/url-from-session-storage-item.js';
import { useBloomreachPageModels } from './use-bloomreach-page-models.js';

/**
 * When there is aab session storage, it is indicating that someone already
 * has entered the funnel, so we generate a url base on session storage
 * otherwise we take the storeCode or else the bloomreach configuration
 */ const STORAGE_KEY = 'aab_appointmentState';
const useBloomreachAppointmentURLsConfiguration = (appointmentMenuItems)=>{
    var ref, ref1;
    const page = useBrPageContext();
    const { storeCode  } = useServerStoreDataContext();
    const { isStoreValueInAabButtonDisabled  } = useFeatureToggles();
    const [sessionStorageItem, setSessionStorageItem] = React.useState('');
    const appointmentState = getSessionStorageItem(STORAGE_KEY);
    const pageModels = useBloomreachPageModels();
    const appointmentRoute = (pageModels === null || pageModels === void 0 ? void 0 : (ref = pageModels.routes) === null || ref === void 0 ? void 0 : ref['appointment-book']) || '';
    React.useEffect(()=>{
        setSessionStorageItem(appointmentState !== null && appointmentState !== void 0 ? appointmentState : '');
    }, [
        appointmentState
    ]);
    if (sessionStorageItem) {
        return urlFromSessionStorageItem({
            sessionStorageItem,
            appointmentMenuItems,
            appointmentRoute
        });
    }
    if (typeof storeCode === 'number' && !isStoreValueInAabButtonDisabled) {
        const searchParams = new URLSearchParams({
            storeId: String(storeCode)
        }).toString();
        return formatRouteForAAB({
            appointmentMenuItems,
            appointmentRoute,
            searchParams,
            route: 'what'
        });
    }
    const content = (ref1 = getBrPageContent(page, pageModels === null || pageModels === void 0 ? void 0 : pageModels.appointmentURLsConfiguration)) === null || ref1 === void 0 ? void 0 : ref1.linkItem;
    try {
        return applyBloomreachAppointmentUrlsConfiguration({
            pathname: (page === null || page === void 0 ? void 0 : page.getUrl()) || '',
            appointmentRoute,
            appointmentMenuItems,
            content
        });
    } catch (e) {
        return appointmentMenuItems;
    }
};

export { useBloomreachAppointmentURLsConfiguration };
//# sourceMappingURL=use-bloomreach-appointment-urls-configuration.js.map
